import { Component, OnInit, ElementRef, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';

@Component({
	selector: 'app-number-general-input',
	templateUrl: './number-general-input.component.html',
	styleUrls: ['./number-general-input.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberGeneralInputComponent extends InputComponent implements OnInit {

	public numericValue = 0;
	public numberString = '';
	public pattern = '[+-]?[0-9]*\.?[0-9]*';
	public minVal = 0;
	public maxVal = Number.MAX_SAFE_INTEGER;
	public allowNegative = true;
	public useSci = false;
	@HostBinding('class.number-general') isMe = true;
	constructor(private domNode: ElementRef, protected cdr: ChangeDetectorRef) {
		super(cdr);
		super._domNode = this.domNode;
	}

	set currentValue(val: any) {

		if (!val) {
			if (val !== 0) {

				if (this.numberString !== '-') {
					this.numberString = '';
				}
				this.numericValue = null;
				super.currentValue = null;
				return;
			}
		}

		super.currentValue = val;
		if (['text', 'string'].indexOf(this.attribute.type) > -1) {
			if (this.hasCasting === true) {
				this.numericValue = NumberQualifierService.FromString('' + val, this.casting.format);
			}
		} else {
			this.numericValue = +val;
		}
		this.numberString = '' + this.numericValue;
	}
	get currentValue(): any {
		return super.currentValue;
	}
	SetAttribute(layer: SLLayer, attribute: AttributeInfo) {
		super.SetAttribute(layer, attribute);
		if (this.hasCasting === true) {
			switch (this.casting.format) {
				case 'sci':
				case 'sci-pow':
					this.useSci = true;
					break;
			}
		}
		let pattern = '';
		if (this.hasCasting === true) {
			if (!!this.casting.plusMinus) {
				pattern += '[' + this.casting.plusMinus + ']';
			}

			pattern += '[0-9]*';
			if (!!this.casting.fixedDigits) {
				if (this.casting.fixedDigits > 0) {
					pattern += '\.?[0-9]{0,' + this.casting.fixedDigits + '}';
				}
				if (!!this.casting.precision) {
					pattern += '\.?[0-9]{0,' + this.casting.precision + '}';
				}
			}
			this.minVal = Number.MIN_SAFE_INTEGER;
			this.maxVal = Number.MAX_SAFE_INTEGER;

			if (!!this.casting.range) {
				if ((this.casting.range.min !== 0) && (this.casting.range.max !== 0) ) {
					this.minVal = this.casting.range.min;
					this.maxVal = this.casting.range.max;
				}
			}
		} else {
			this.minVal = Number.MIN_SAFE_INTEGER;
			this.maxVal = Number.MAX_SAFE_INTEGER;
			switch (attribute.type) {
				case 'int':
					pattern += '[+-]?[0-9]*';
					break;
				case 'float':
					pattern += '[+-]?[0-9]*\.?[0-9]*';
			}
		}
		this.currentValue = this.currentValue;
	}

	NumberChanged(inputVal: any) {
		this.numberString = inputVal.target.value;
		if (inputVal.target.value === '') {
			if (inputVal.key === '-') {
				this.numberString = '-';
				return;
			}
		}

		if (this.numberString !== '') {
			this.numericValue = Number(this.numberString);
			if (this.numericValue < this.minVal) {
				this.numericValue = this.minVal;
			}
			if (this.numericValue > this.maxVal) {
				this.numericValue = this.maxVal;
			}
			this.numberString = '' + this.numericValue;
		} else {
			this.numericValue = null;
			this.currentValue = this.numericValue;
			return;
		}

		switch (this.attribute.type) {
			case 'string':
			case 'text':
				if (this.hasCasting === true) {
					let digits: number = null;
					if (!!this.casting.fixedDigits) {
						digits = this.casting.fixedDigits;
					}
					if (!!this.casting.precision) {
						digits = this.casting.precision;
					}
					this.currentValue = NumberQualifierService.ToString(this.numericValue,
						this.casting.format, digits, this.casting.negFormat);
				} else {
					this.currentValue = '' + this.numericValue;
				}
				break;
			case 'int':
				this.numericValue = Math.floor(this.numericValue);
				this.currentValue = '' + this.numericValue;
				break;
			default:
				this.currentValue = this.numericValue;
				break;
		}
	}

}
